<template>
  <div>
    <div class="header">
      <el-row>
        <el-radio-group
          v-model="detail.statisticsStatus"
          @change="getStatistics"
          fill="#3875FF"
          text-color="#fff"
          size="small"
        >
          <el-radio-button label="1" size="medium">本年 </el-radio-button>
          <el-radio-button label="2" size="medium">本季度 </el-radio-button>
          <el-radio-button label="3" size="medium">本月 </el-radio-button>
        </el-radio-group>
        <el-select
          style="padding-left: 30px"
          v-model="detail.customerType"
          clearable
          @change="getStatistics"
          placeholder="请选择工单类型"
          size="small"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-date-picker
          class="datepicker"
          v-model="times"
          type="datetimerange"
          value-format="yyyy-MM-dd HH:mm:ss"
          @change="datetime"
          range-separator="至"
          start-placeholder="服务开始时间"
          end-placeholder="服务结束时间"
          size="small"
        >
        </el-date-picker>
      </el-row>
      <ul class="manage_header">
        <li class="header_item header_item1">
          <div class="imgFlex">
            <img src="../assets/img/setIcon1.png" alt="" srcset="" />
          </div>
          <div class="contentBox">
            <p class="setTitle">服务总数</p>
            <h4 class="setNum">{{ list.oldPersonTotal }}</h4>
          </div>
        </li>
        <li class="header_item header_item2">
          <div class="imgFlex">
            <img src="../assets/img/setIcon2.png" alt="" srcset="" />
          </div>
          <div class="contentBox">
            <p class="setTitle">服务工单总数</p>
            <h4 class="setNum">{{ list.pgdTotal }}</h4>
          </div>
        </li>
        <li class="header_item header_item3">
          <div class="imgFlex">
            <img src="../assets/img/setIcon3.png" alt="" srcset="" />
          </div>
          <div class="contentBox">
            <p class="setTitle">服务时长总数</p>
            <h4 class="setNum">{{ list.periodTotal }}</h4>
          </div>
        </li>
        <li class="header_item header_item4">
          <div class="imgFlex">
            <img src="../assets/img/setIcon4.png" alt="" srcset="" />
          </div>
          <div class="contentBox">
            <p class="setTitle">服务老人总金额</p>
            <h4 class="setNum">{{ list.moneyTotal }}</h4>
          </div>
        </li>
      </ul>
    </div>

    <div class="table-box">
      <QueryForm @QuerySearch="QuerySearch" :queryForm="queryForm"></QueryForm>
      <div style="display: none">
        <input
          @change="(e) => uploadInfo(e, '4')"
          id="speechUpload"
          type="file"
        />
      </div>
      <el-button
        type="primary"
        icon="el-icon-download"
        class="button downOutBtns"
        size="small"
        @click="createExcel"
        >导出
      </el-button>
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        :header-cell-style="{ background: '#f2f2f2', color: '#000' }"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="index"
          width="70"
          label="序号"
          align="center"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="orderNum"
          label="工单流水号"
          align="center"
          width="220"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="customerName"
          label="客户姓名"
          align="center"
          width="180"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="address"
          label="居住地址"
          align="center"
          width="220"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="customerphone"
          label="联系方式"
          align="center"
          width="150"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="servetypename"
          label="服务类别"
          align="center"
          width="180"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="serveproductName"
          label="服务项目"
          align="center"
          width="120"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="price"
          label="价格"
          align="center"
          width="120"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="timeStart"
          label="服务开始时间"
          align="center"
          width="220"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="timeEnd"
          label="服务结束时间"
          align="center"
          width="220"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="realPeriod"
          label="时间工作时间/分钟"
          align="center"
          width="180"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          :show-overflow-tooltip="true"
          width="150"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-button type="text" @click="detailsVisit('查看', scope.row)"
              >查看
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 40, 100]"
        :page-size="query.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
      >
      </el-pagination>
    </div>

    <el-dialog
      title="查看"
      :visible.sync="dialogVisible"
      :before-close="cancel"
      width="65%"
    >
      <el-form
        :inline="true"
        :model="serverObj"
        ref="ruleForm"
        label-width="140px"
        class="demo-ruleForm"
        disabled
      >
        <div style="height: 12px; margin-top: 30px; color: #169bd5">
          客户信息
        </div>
        <el-divider></el-divider>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="客户姓名：">
              <el-input
                v-model="serverObj.customerName"
                size="medium"
                @click.native="inputClickName"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="工单类型：" prop="customerType">
              <el-select
                style="width: 100%"
                v-model="serverObj.customerType"
                placeholder="请选择"
                size="medium"
              >
                <el-option label="商业服务工单" value="7"></el-option>
                <el-option label="残联服务工单" value="3"></el-option>
                <el-option label="老干服务工单" value="4"></el-option>
                <el-option label="民政服务工单" value="6"></el-option>
                <el-option label="文明办服务工单" value="10"></el-option>
                <el-option label="退役军人服务工单" value="14"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="联系方式：" prop="customerphone">
              <el-input
                v-model="serverObj.customerphone"
                size="medium"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系地址：" prop="address">
              <el-input v-model="serverObj.address" size="medium"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <div style="height: 12px; margin-top: 30px; color: #169bd5">
          服务工单
        </div>
        <el-divider></el-divider>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="工单流水号：">
              <el-input v-model="serverObj.orderNum" size="medium"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="套餐类型：" prop="ensure">
              <el-select
                v-model="serverObj.ensure"
                placeholder="请选择"
                style="width: 100%"
                size="medium"
              >
                <el-option
                  v-for="item in ensureList"
                  :key="item.id"
                  :label="item.mealType"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="服务类别：">
              <el-input
                v-model="serverObj.servetypename"
                size="medium"
                placeholder="选择服务项目展示服务类别"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="服务时长：" prop="period">
              <el-input v-model="serverObj.period" size="medium"
                ><i slot="suffix">分钟</i></el-input
              >
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="服务项目：">
              <el-input
                v-model="serverObj.serveproductName"
                size="medium"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="服务价格：">
              <el-input v-model="serverObj.price" size="medium"
                ><i slot="suffix">元</i></el-input
              >
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="服务开始时间：">
              <el-input v-model="serverObj.timeStart" size="medium"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="服务结束时间：">
              <el-input v-model="serverObj.timeEnd" size="medium">
                &lt;
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <div style="height: 12px; margin-top: 30px; color: #169bd5">
          服务人员
        </div>
        <el-divider></el-divider>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="机构：">
              <el-input
                v-model="serverObj.servestationName"
                @click.native="inputClickStation"
                size="medium"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="服务人员：" prop="servePersonName">
              <el-input
                v-model="serverObj.servePersonName"
                size="medium"
                @click.native="serveName1Fn"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系方式：" prop="servePersonPhone">
              <el-input
                v-model="serverObj.servePersonPhone"
                size="medium"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import request from "@/utils/request.js"
import QueryForm from "@/component/queryform.vue"

export default {
  components: {
    QueryForm,
  },
  data() {
    return {
      serverObj: {},
      times: [],
      dialogVisible: false,
      showVisit: false,
      showTitle: "",
      queryForm: {
        orderName: "",
        customerType: "",
        serveproductName: "",
        servestationName: "",
        servePersonName: "",
      },
      list: {
        oldPersonTotal: 0,
        pgdTotal: 0,
        periodTotal: 0,
        moneyTotal: 0,
      },
      detail: {
        statisticsStatus: "1",
        customerType: "",
      },
      tableData: [],
      orderInfo: {
        customerName: "",
      },
      //客户下拉框的值
      options: [
        {
          value: "7",
          label: "商业服务工单",
        },
        {
          value: "3",
          label: "残联服务工单",
        },
        {
          value: "4",
          label: "老干服务工单",
        },
        {
          value: "6",
          label: "民政服务工单",
        },
        {
          value: "10",
          label: "文明办服务工单",
        },
        {
          value: "14",
          label: "退役军人服务工单",
        },
      ],
      ensureList: [],
      totalCount: 0,
      query: {
        pageNo: 1,
        pageSize: 10,
      },
    }
  },
  created() {
    this.getDataList()
    this.getStatistics()
    this.getEnsureList()
  },
  methods: {
    cancel() {
      this.serverObj = {}
      this.dialogVisible = false
    },
    createExcel() {
      this.request2({
        url: "/jjyl/servicePgdExport/info/downloadException",
        method: "POST",
        excel: true,
        data: {
          customerphone: this.queryForm.customerphone,
          pageNo: this.query.pageNo,
          pageSize: this.query.pageSize,
          orderNum: this.queryForm.orderNum,
          customerType: this.queryForm.customerType,
          customerName: this.queryForm.customerName,
          timeStart: this.queryForm.timeStart,
          timeEnd: this.queryForm.timeEnd,
          position: this.queryForm.position,
          servestationName: this.queryForm.servestationName,
          serveproductName: this.queryForm.serveproductName,
          servePersonName: this.queryForm.servePersonName,
        },
        responseType: "blob",
      }).then((res) => {
        if (res) {
          const blob = new Blob([res], {
            type: "application/vnd.ms-excel",
          })
          const fileName = "工单结算管理.xls"
          const linkNode = document.createElement("a")
          linkNode.download = fileName //a标签的download属性规定下载文件的名称
          linkNode.style.display = "none"
          linkNode.href = URL.createObjectURL(blob) //生成一个Blob URL
          document.body.appendChild(linkNode)
          linkNode.click() //模拟在按钮上的一次鼠标单击
          URL.revokeObjectURL(linkNode.href) // 释放URL 对象
          document.body.removeChild(linkNode)
          this.$message.success("导出表格成功")
        }
      })
    },
    async fileChange(event) {
      const file = event.target.files[0]
      const personType = "1"
      let config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
      let formData = new FormData()
      formData.append("personType", personType)
      formData.append("file", file)
      let result = await this.$http.post(
        "/jjyl/servicePgd/info/ServicePgdExcel",
        formData,
        config
      )
      // 清空文件
      const fileEle = document.getElementById("speechUpload")
      fileEle.value = ""
      if (result.code === 200) {
        this.$message.success(result.message)
        this.getDataList()
      } else {
        this.$message.warning(result.message)
      }
    },
    typology() {
      console.log(111)
    },
    datetime(val) {
      // console.log(val)
      this.detail.timeStart = val[0]
      this.detail.timeEnd = val[1]
      this.getStatistics()
    },
    getStatistics() {
      request({
        url: "/jjyl/servicePgd/info/accountManageStatistics",
        method: "POST",
        data: {
          ...this.detail,
        },
      }).then((res) => {
        if (res.code === 200 && res.content) {
          this.list = res.content
        }
      })
    },
    getDataList() {
      let params = {
        pageNo: this.query.pageNo,
        pageSize: this.query.pageSize,
        orderNum: this.queryForm.orderNum,
        states: "3",
        typeStatus: 1,
        ...this.queryForm,
        // customerphone: this.queryForm.customerphone,
        // customerName: this.queryForm.customerName,
        // timeStart: this.queryForm.timeStart,
        // timeEnd: this.queryForm.timeEnd,
        // position: this.queryForm.position,
        // provinceId: this.queryForm.provinceId,
        // cityId: this.queryForm.cityId,
        // areaId: this.queryForm.areaId,
        // streetId: this.queryForm.streetId,
        // communityId: this.queryForm.communityId,
        // servestationName: this.queryForm.servestationName,
        // serveproductName: this.queryForm.serveproductName,
        // servePersonName: this.queryForm.servePersonName
      }
      request({
        url: "/jjyl/servicePgd/info/findServicepgd",
        method: "POST",
        data: params,
      }).then((res) => {
        if (res.code === 200) {
          if (res.content) {
            this.tableData = res.content.list
            this.totalCount = res.content.count
          } else {
            this.tableData = []
            this.totalCount = 0
          }
        }
      })
    },
    async detailsVisit(title, row) {
      console.log(row, 444)
      this.serverObj = row
      this.showTitle = title
      await this.getDetails(row.id)
      this.dialogVisible = true
    },
    // 获取套餐类型列表
    getEnsureList() {
      request({
        url: "/jjyl/admin/meal/info/findList",
        method: "POST",
        data: {
          pageNo: 1,
          pageSize: 9999,
          states: "1",
        },
      }).then((res) => {
        if (res.code === 200 && res.content) {
          const arr = res.content.list || []
          arr.forEach((item) => {
            item.id = item.id + ""
          })
          this.ensureList = arr.filter((item) => {
            return item.states == "1"
          })
        }
      })
    },
    getDetails(id) {
      request({
        url: "/jjyl/servicePgd/info/findServicepgdById",
        method: "POST",
        data: {
          id: id,
        },
      }).then((res) => {
        if (res.code === 200) {
          if (res.content) {
            this.orderInfo = res.content
          } else {
            this.orderInfo = {}
          }
        }
      })
    },
    QuerySearch() {
      this.getDataList()
    },
    handleSelectionChange(val) {},
    handleSizeChange(val) {
      this.query.pageSize = val
      this.getDataList()
    },
    handleCurrentChange(val) {
      this.query.pageNo = val
      this.getDataList()
    },
  },
}
</script>

<style lang="less" scoped>
/deep/ .el-radio-button {
  margin-right: 10px;
  border-radius: 4px;
  overflow: hidden;
  .el-radio-button__inner {
    background: #f1f5ff;
    color: #7587c5;
    border: 0;
    width: 80px;
  }
}

.header {
  background: #fff;
  padding: 15px;
  border-radius: 16px;
}
.QuerySearchBtn {
  margin-left: 60px;
}

.table-operation {
  width: 100%;
  display: flex;
  cursor: pointer;
  justify-content: center;

  div {
    flex: 1;
  }
}

.labelImportBtn {
  margin: 0 10px;

  span {
    width: 70px;
    height: 40px;
    text-align: center;
    display: inline-block;
    line-height: 40px;
    font-size: 14px;
    background-color: #409eff;
    cursor: pointer;
    color: #ffffff;
    border-radius: 5px;
  }
}

.manage_header {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;

  .header_item {
    height: 100px;
    align-items: center;
    display: flex;
    box-sizing: border-box;
    border-radius: 5px;
    background: url(../assets/img/setTitle.png) no-repeat;
    background-size: cover;

    .imgFlex {
      text-align: left;
      padding-left: 30px;

      img {
        display: inline-block;
        width: 60px;
        height: 60px;
      }
    }

    .contentBox {
      margin-left: 20px;
      padding-right: 30px;
      width: 160px;
      color: #333333;
      font-size: 16px;

      .setTitle {
      }

      .setNum {
        padding-top: 10px;
        font-weight: bold;
        color: #666666;
      }
    }
  }

  .price {
    font-size: 36px;
    font-family: Unidtrsmled;
    color: #1e1e1e;
    text-align: center;
  }
}

.datepicker {
  margin-left: 30px;

  /deep/ .el-input__inner {
    height: 36px;
    line-height: 36px;
  }
}
</style>
